import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { UserPermissionDto } from './permissions.dto';

export class PermissionsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/permissions');
  }

  public async getAllPermissions() {
    return await this.instance.get('/').then((response: AxiosResponse<UserPermissionDto[]>) => response.data);
  }
}
